import axios from "axios";
import { uploadAsset } from "../api/assetUpload";

export function validateVisitorProfileImageFile(file) {
    if (!file) return false;
    const isJpgOrPng = file.type === "image/jpeg" || file.type === "image/jpg" || file.type === "image/png";
    if (!isJpgOrPng) return false;
    return file.size / 1024 / 1024 < 20;
}

/**
 * Ziyaretçi profil fotoğrafı için Asset oluşturur ve S3 yükleme isteğini tamamlar.
 * @param {string} siteId
 * @param {string} visitorId
 * @param {File} file
 * @returns {Promise<object>} asset
 */
export async function uploadVisitorProfileImageAsset(siteId, visitorId, file) {
    const path = siteId + "/visitor-profile/" + visitorId + "/";
    const uploadData = await uploadAsset({
        path: path,
        mime: file.type,
        name: file.name,
        size: file.size,
        type: "visitor",
    });
    await axios({
        method: uploadData.data.method,
        url: uploadData.data.url,
        data: file,
        headers: { "Content-Type": "application/octet-stream" },
    });
    return uploadData.data.asset;
}
